import { useEffect, useMemo, useState } from "react";
import { apiRequest } from "../api/client";
import { createPublicServices } from "../services/invitation-services";
import { getTemplate } from "../template-registry";
import type { WeddingData } from "../types/wedding";

interface PublicResponse {
  ok: true;
  project: { id: string; slug: string; templateId: string; templateVersion: string; publishedAt: string };
  data: WeddingData;
}

export function PublicInvitation({ slug }: { slug: string }) {
  const [response, setResponse] = useState<PublicResponse | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    apiRequest<PublicResponse>(`/api/public/${encodeURIComponent(slug)}`)
      .then(setResponse)
      .catch((caught) => setError(caught instanceof Error ? caught.message : "Invitation not found."));
  }, [slug]);
  const services = useMemo(() => createPublicServices(slug), [slug]);
  if (error) return <main className="public-not-found"><span>404</span><h1>Invitation not found</h1><p>{error}</p></main>;
  if (!response) return <div className="invitation-loading"><span>♡</span><p>Opening invitation…</p></div>;
  const template = getTemplate(response.project.templateId);
  const Renderer = template.renderer;
  return <Renderer data={response.data} mode="public" services={services} />;
}
